import LoginEffect from './LoginEffect';
import HttpErrorResponseModel from '../../models/HttpErrorResponseModel';
import ActionUtility from '../../utilities/ActionUtility';
import { ReduxDispatch } from '../../models/ReduxProps';
import IStore from '../../models/IStore';
import ValidateAccountModel from './models/login/ValidateAccountModel';
import UserAuthenticatedModel from './models/login/UserAuthenticatedModel';
import TokenModel from './models/login/TokenModel';

type ActionUnion = undefined | HttpErrorResponseModel | ValidateAccountModel | UserAuthenticatedModel | TokenModel;

export default class LoginAction {
    public static readonly REQUEST_VALIDATE_ACCOUNT: string = 'LoginAction.REQUEST_VALIDATE_ACCOUNT';
    public static readonly REQUEST_VALIDATE_ACCOUNT_FINISHED: string = 'LoginAction.REQUEST_VALIDATE_ACCOUNT_FINISHED';
    public static readonly REQUEST_VALIDATE_ACCOUNT_RESET: string = 'LoginAction.REQUEST_VALIDATE_ACCOUNT_RESET';

    public static readonly REQUEST_AUTHENTICATE: string = 'LoginAction.REQUEST_AUTHENTICATE';
    public static readonly REQUEST_AUTHENTICATE_FINISHED: string = 'LoginAction.REQUEST_AUTHENTICATE_FINISHED';
    public static readonly REQUEST_AUTHENTICATE_RESET: string = 'LoginAction.REQUEST_AUTHENTICATE_FINISHED';

    public static readonly RESET_ACCOUNT: string = 'LoginAction.RESET_ACCOUNT';
    public static readonly RESET_USERNAME: string = 'LoginAction.RESET_ACCOUNT';

    public static readonly CURRENT_COMPONENT: string = 'LoginAction.CURRENT_COMPONENT';
    public static readonly ACTUALIZE_USERNAME: string = 'LoginAction.ACTUALIZE_USERNAME';

    public static readonly REQUEST_ERROR: string = 'LoginAction.REQUEST_ERROR';
    public static readonly REQUEST_ERROR_FINISHED: string = 'LoginAction.REQUEST_ERROR_FINISHED';

    public static readonly REQUEST_TOKEN: string = 'LoginAction.REQUEST_TOKEN';
    public static readonly REQUEST_TOKEN_FINISHED: string = 'LoginAction.REQUEST_TOKEN_FINISHED';

    public static readonly INSERT_BANNER: string = 'LoginAction.INSERT_BANNER';
    public static readonly REMOVE_BANNER: string = 'LoginAction.REMOVE_BANNER';

    public static readonly SET_GEOLOCATION: string = 'LoginAction.SET_GEOLOCATION';
    public static readonly SET_GEO_USER_CONSENT: string = 'LoginAction.SET_GEO_USER_CONSENT';
    public static readonly SET_GEO_IS_BLOCKED: string = 'LoginAction.SET_GEO_IS_BLOCKED';

    public static requestValidateAccount(username: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore): Promise<void> => {
            await ActionUtility.createThunkEffect<ValidateAccountModel>(
                dispatch,
                LoginAction.REQUEST_VALIDATE_ACCOUNT,
                LoginEffect.requestValidateAccount,
                { account: username }
            );
        };
    }

    public static requestAuthenticate(password: any, token: any, geolocation: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore): Promise<void> => {
            var payload = { account: getState().login.username, password: password, token: token };
            const headers = { Geolocation: geolocation };
            await ActionUtility.createThunkEffect<UserAuthenticatedModel>(
                dispatch,
                LoginAction.REQUEST_AUTHENTICATE,
                LoginEffect.requestAuthenticate,
                payload,
                headers
            ).then((data: any) => {
                const handshake = getState().handshake.handshake;
                if (data.token !== undefined && data.token.length > 0) {
                    window.location.href = handshake?.loginUrls?.onSuccessRedirect + `/?jwt=${data.token}`;
                }
            });
        };
    }

    public static ResetValidateAccount(): any {
        return ActionUtility.createAction(LoginAction.REQUEST_VALIDATE_ACCOUNT_FINISHED);
    }

    public static ResetAccount(): any {
        return ActionUtility.createAction(LoginAction.RESET_ACCOUNT);
    }

    public static ResetUsername(): any {
        return ActionUtility.createAction(LoginAction.RESET_USERNAME);
    }

    static SetCurrentComponent(nextComponent: any): any {
        return ActionUtility.createAction(LoginAction.CURRENT_COMPONENT, nextComponent);
    }

    static ActualizeUsername(username: any): any {
        return ActionUtility.createAction(LoginAction.ACTUALIZE_USERNAME, username);
    }

    public static requestToken(username: string, password: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore): Promise<void> => {
            await ActionUtility.createThunkEffect<TokenModel>(dispatch, LoginAction.REQUEST_TOKEN, LoginEffect.requestToken, {
                username: username,
                password: password,
            }).then((data) => {
                //Remover más adelente
                localStorage.setItem('user', JSON.stringify(data));
            });
        };
    }

    public static AddBanner(banner: any) {
        return ActionUtility.createAction(LoginAction.INSERT_BANNER, banner);
    }

    public static RemoveBanner(array: any, remove: any) {
        const index = array.findIndex((item: { id: any }) => item.id === remove);
        if (index > -1) {
            array.splice(index, 1);
        }
        return ActionUtility.createAction(LoginAction.REMOVE_BANNER, array);
    }

    static SetGeoUserConsent(userConsent: boolean): any {
        return ActionUtility.createAction(LoginAction.SET_GEO_USER_CONSENT, userConsent);
    }

    static SetGeoIsBlocked(): any {
        return ActionUtility.createAction(LoginAction.SET_GEO_IS_BLOCKED);
    }

    static SetGeolocation(geolocation: any): any {
        return ActionUtility.createAction(LoginAction.SET_GEOLOCATION, geolocation);
    }
}
